<div data-testid="logic-transfer-page" class="p-6 flex-table-page">
  <!-- Header -->
  <div class="mb-6 flex-table-header">
    <h2 class="text-2xl font-semibold text-gray-800">
      {{ "warehouse_transfer.title" | translate }}
    </h2>
  </div>

  <!-- Search Form -->
  <app-search-form
    data-testid="logic-transfer-search-form"
    [searchFormat]="searchConfig()"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions" class="flex gap-2">
      <app-button
        [testId]="'logic-transfer-column-config-btn'"
        type="success"
        [outlined]="true"
        icon="view_column"
        (emitOnClick)="onColumnConfigClick($event)"
      ></app-button>
      <app-status-filter
        [primaryButton]="primaryButton()"
        (primaryButtonClick)="onAddNew()"
      ></app-status-filter>
    </div>
  </app-search-form>

  <!-- Data Table -->
  <div class="table-section flex-table-section">
    <advanced-data-table
      data-testid="logic-transfer-table"
      #advancedTable
      [dataSource]="filteredLogicTransferItems()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [loading]="loading()"
      [rows]="searchParams().size"
      [first]="(searchParams().page - 1) * searchParams().size"
      [totalRecords]="totalRecords()"
      [sortField]="sortField()"
      [sortOrder]="sortOrder()"
      scrollHeight="flex"
      [showInternalColumnConfigButton]="false"
      class="w-full"
      (pageChange)="onPageChange($event)"
      (sortChange)="onSortChange($event)"
    >
      <!-- Status Template -->
      <ng-template #statusTemplate let-status>
        <div class="flex items-center justify-center gap-1">
          <span [class]="'status-badge status-' + status">
            {{ formatLogicTransferStatus(status) | translate }}
          </span>
        </div>
      </ng-template>

      <!-- Custom Template for Expected Receive Date and Creation Time -->
      <ng-template
        #customTemplate
        let-value
        let-rowData="rowData"
        let-column="column"
      >
        @if (column.prop === "expectedReceiveDate") {
          <!-- Expected Receive Date -->
          <span class="text-xs text-gray-600">
            {{ formatExpectedReceiveDate(value) }}
          </span>
        } @else if (column.prop === "creationDate") {
          <!-- Creation Time -->
          <span class="text-xs text-gray-600">
            {{ formatCreationTime(value) }}
          </span>
        }
      </ng-template>

      <!-- Custom Actions Template -->
      <ng-template #actionsTemplate let-record>
        <div class="inline-flex items-center gap-2 whitespace-nowrap">
          <!-- View button -->
          @if (canRead()) {
            <span
              [attr.data-testid]="'logic-transfer-action-view-' + record.id"
              (click)="onActionClick('view', record)"
              class="action-link action-view cursor-pointer"
            >
              {{ "common.actions.view" | translate }}
            </span>
          }

          <!-- Others button - only visible if there are actions (excluding view) after permission filtering -->
          @if (hasOtherActions(record)) {
            <button
              [attr.data-testid]="'logic-transfer-action-others-' + record.id"
              type="button"
              class="action-link action-others cursor-pointer"
              aria-haspopup="menu"
              (click)="toggleMenu($event, record)"
            >
              {{ "common.actions.others" | translate }}
            </button>
          }
        </div>
      </ng-template>
    </advanced-data-table>
  </div>

  <!-- Confirmation Dialog -->
  <p-confirmDialog data-testid="logic-transfer-confirmation-dialog"></p-confirmDialog>

  <!-- Single Menu for All Actions -->
  <p-menu
    data-testid="logic-transfer-actions-menu"
    #actionMenu
    [popup]="true"
    [model]="currentMenuModel()"
    appendTo="body"
    [baseZIndex]="2100"
    styleClass="actions-menu text-[0.75rem]"
    [autoZIndex]="true"
  ></p-menu>

  <!-- Confirmation Dialog for Approve -->
  <app-confirmation-dialog
    [testId]="'logic-transfer-approve-dialog'"
    [visible]="showApproveDialog()"
    [title]="'logic_transfer.dialog.confirm_approve.title' | translate"
    [message]="'logic_transfer.dialog.confirm_approve.message' | translate"
    [buttons]="approveDialogButtons"
    (emitOnClick)="onApproveConfirm($event)"
  ></app-confirmation-dialog>

  <!-- Confirmation Dialog for Delete -->
  <app-confirmation-dialog
    [testId]="'logic-transfer-delete-dialog'"
    [visible]="showDeleteDialog()"
    [title]="'logic_transfer.dialog.confirm_delete.title' | translate"
    [message]="'logic_transfer.dialog.confirm_delete.message' | translate"
    [buttons]="deleteDialogButtons"
    (emitOnClick)="onDeleteConfirm($event)"
  ></app-confirmation-dialog>

  <!-- Confirmation Dialog for Cancel -->
  <app-confirmation-dialog
    [testId]="'logic-transfer-cancel-dialog'"
    [visible]="showCancelDialog()"
    [title]="'logic_transfer.dialog.confirm_cancel.title' | translate"
    [message]="'logic_transfer.dialog.confirm_cancel.message' | translate"
    [buttons]="cancelDialogButtons"
    (emitOnClick)="onCancelConfirm($event)"
  ></app-confirmation-dialog>

  <!-- Error Dialog for Approve -->
  <app-confirmation-dialog
    [testId]="'logic-transfer-approve-error-dialog'"
    [visible]="showApproveErrorDialog()"
    [title]="'logic_transfer.dialog.error_approve.title' | translate"
    [message]="approveErrorMessage()"
    [buttons]="approveErrorDialogButtons"
    [width]="'600px'"
    (emitOnClick)="onApproveErrorClose($event)"
  ></app-confirmation-dialog>
</div>
